/**
 * Shared animation variants — backward-compatible exports.
 *
 * For mobile-aware animations, use `useMotionBudget()` from
 * `src/app/hooks/useMotionBudget.ts` instead of these static variants.
 *
 * These exports remain as the DESKTOP defaults for consumers that
 * don't need responsive animation budgeting.
 */

export { MOTION_BUDGET } from '../../app/hooks/useMotionBudget'

export const containerVariants = {
  hidden: { opacity: 0 },
  visible: { opacity: 1, transition: { staggerChildren: 0.1 } },
}

export const itemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: { type: 'spring', bounce: 0.4, duration: 0.8 },
  },
}
